<template>
  <div>
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="data"
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          class="mb-0"
          v-model="displayText"
          :label="label"
          :style="{ 'min-width': width }"
          :placeholder="placeholder"
          :hide-details="hideDetails"
          :outlined="outlined"
          :dense="dense"
          :filled="filled"
          :clearable="clearable"
          readonly
          v-bind="attrs"
          v-on="on"
          @click:clear="clear"
        >
          <template v-slot:prepend-inner>
            <div>
              <v-menu v-model="showMenu" offset-y style="max-width: 600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    {{ filterClauseItems[filterClauseSelected].icon }}
                  </v-icon>
                </template>

                <v-list>
                  <v-list-item-group
                    v-model="filterClauseSelected"
                    mandatory
                    color="primary"
                  >
                    <v-list-item
                      v-for="(item, i) in filterClauseItems"
                      :key="i"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="data"
        :no-title="noTitle"
        scrollable
        :range="range"
        :active-picker.sync="activePicker"
        show-adjacent-months
        show-week
        color="primary"
        header-color="date"
        first-day-of-week="1"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="$refs.dialog.save(data)">
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>

    <!-- <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          class="mb-0"
          v-model="displayText"
          :label="label"
          :style="{ 'min-width': width }"
          :placeholder="placeholder"
          :hide-details="hideDetails"
          :outlined="outlined"
          :dense="dense"
          :filled="filled"
          :clearable="clearable"
          readonly
          v-bind="attrs"
          v-on="on"
          @click:clear="clear"
        >
          <template v-slot:prepend-inner>
            <div>
              <v-menu v-model="showMenu" offset-y style="max-width: 600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    {{ filterClauseItems[filterClauseSelected].icon }}
                  </v-icon>
                </template>

                <v-list>
                  <v-list-item-group
                    v-model="filterClauseSelected"
                    mandatory
                    color="primary"
                  >
                    <v-list-item
                      v-for="(item, i) in filterClauseItems"
                      :key="i"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="data"
        show-adjacent-months
        :range="range"
        :active-picker.sync="activePicker"
        show-week
        color="primary"
        @change="save"
      ></v-date-picker>
    </v-menu> -->
  </div>
</template>

<script>
import moment from "moment";
import dataTablefilterClause from "@/helpers/data/dataTablefilterClause.json";
export default {
  props: {
    value: {
      required: true,
    },
    filterClause: {
      default: null,
    },
    label: {
      default: "",
    },
    placeholder: {
      default: null,
    },
    noTitle: {
      type: Boolean,
      default: true,
    },
    "hide-details": {
      default: "auto",
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: "DD.MM.YYYY",
    },
  },
  data: () => ({
    activePicker: null,
    date: null,
    menu: false,
    modal: false,
    showMenu: false,
    width: "0px",
  }),
  watch: {
    // menu(val) {
    //   val &&
    //     setTimeout(() => {
    //       // if (!this.data && this.data.length === 0) {
    //       //   this.activePicker = "YEAR";
    //       // }
    //     });
    // },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    setWidth(value) {
      this.width = value ? value.length * 6 + 100 + "px" : "100px";
    },
    clear() {
      this.data = null;
    },
  },
  computed: {
    data: {
      get() {
        if (this.range && !this.value) {
          return [];
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    displayText: {
      get() {
        var value = null;
        if (this.range) {
          value = this.data
            .map((x) => moment(x).format(this.format))
            .join(" ~ ");
        } else {
          value = this.data ? moment(this.data).format(this.format) : this.data;
        }

        this.setWidth(value);
        return value;
      },
      set(value) {
        this.data = value;
      },
    },
    filterClauseSelected: {
      get() {
        return this.filterClause !== null && this.filterClauseItems
          ? this.filterClauseItems.findIndex((x) => x.id === this.filterClause)
          : 0;
      },
      set(value) {
        //New mulit it not equal old value
        if (this.filterClauseItems[value].multi !== this.range) {
          //If new value is multi then set array
          this.data = this.filterClauseItems[value].multi ? [] : "";
        }
        // mulit verdi har forandret seg. Da skal data endres
        var newValue = this.filterClauseItems[value].id;
        this.$emit("update:filterClause", newValue);
      },
    },
    filterClauseItems() {
      return dataTablefilterClause.date;
    },
    range() {
      return this.filterClauseItems[this.filterClauseSelected].multi;
    },
  },
};
</script>
